import type { FC } from 'react';

import { NON_BREAKING_SPACE } from 'utils/constants/common';

import { useSliceRowItems } from 'components/CampaignCard/CampaignInfo/Targetings/utils';

interface Props {
    titleTrl: string;
    items: Array<string>;
}

const InfoRow: FC<Props> = ({ titleTrl, items }) => (
    <>
        {titleTrl}
        {NON_BREAKING_SPACE}
        {useSliceRowItems(titleTrl.length, items).stringItems}
    </>
);

export default InfoRow;
